import { defineMessages, IntlShape } from "react-intl";
import { nonEmpty, pipe, string, trim } from "valibot";

export const messages = defineMessages({
  public: { defaultMessage: "Public" },
  publicExplanation1: {
    defaultMessage: "Anyone can view this workspace. Only you can edit it.",
  },
  publicExplanation2: {
    defaultMessage:
      "Anyone can view this workspace. Only you or your team can edit it.",
  },
  private: { defaultMessage: "Private" },
  privateExplanation1: {
    defaultMessage: "Only you can view and edit this workspace.",
  },
  privateExplanation2: {
    defaultMessage: "Only you or your team can view and edit this workspace.",
  },
});

export const nameSchema = (intl: IntlShape) =>
  pipe(
    string(intl.formatMessage({ defaultMessage: "Name is required" })),
    trim(),
    nonEmpty(intl.formatMessage({ defaultMessage: "Name is required" })),
  );
